import React, { useState, useRef } from 'react';
import { BiTrash } from "react-icons/bi";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Table } from 'react-bootstrap';

const Filter = (props) => {
  const [localFilter, setLocalFilter] = useState({
    filter_name: '',
    filter_value: '',
    images: []
  });

  const fileInputRef = useRef(null);

  // Accumulate images instead of replacing them
  const handleImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      setLocalFilter(prev => ({
        ...prev,
        images: [...(prev.images || []), ...newFiles]
      }));
      // Reset input so same file can be re-picked if needed
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  // Remove a single preview image before adding the filter row
  const handleRemovePreviewImage = (imgIndex) => {
    setLocalFilter(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== imgIndex)
    }));
  };

  const handleAddFilter = () => {
    if (!localFilter.filter_name || !localFilter.filter_value) {
      alert("Please fill both filter type and variant");
      return;
    }
    props.setFilterList([...(props.filterList || []), localFilter]);
    setLocalFilter({ filter_name: '', filter_value: '', images: [] });
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleRemoveFilter = (index) => {
    const newList = [...(props.filterList || [])];
    newList.splice(index, 1);
    props.setFilterList(newList);
  };

  return (
    <div>
      <div className="container mt-4 mb-4">
        <div className="section">
          <div className="row align-items-center">
            <div className="col-md-12 mt-2">
              <div className="card p-4">
                <h6 className="mb-3 fw-bold">Add Custom Attributes &amp; Colors</h6>

                {/* Input Row */}
                <div className="row mb-2 g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label small text-muted mb-1">Attribute Type</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g., Color, Material"
                      value={localFilter.filter_name}
                      onChange={e => setLocalFilter({ ...localFilter, filter_name: e.target.value })}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small text-muted mb-1">Attribute Value</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g., Red, Cotton"
                      value={localFilter.filter_value}
                      onChange={e => setLocalFilter({ ...localFilter, filter_value: e.target.value })}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small text-muted mb-1">
                      Add Images &nbsp;
                      <span className="text-primary fw-semibold">
                        ({localFilter.images.length} selected — click again to add more)
                      </span>
                      <small className="d-block text-primary mt-1" style={{ fontSize: '11px' }}>Recommended: 500x500 (small) to 800x800 (large) pixels</small>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      multiple
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={handleImageChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      type="button"
                      className="btn btn-primary w-100 fw-bold"
                      onClick={handleAddFilter}
                      title="Add Attribute"
                    >
                      Add <AiOutlinePlusCircle style={{ fontSize: 18 }} />
                    </button>
                  </div>
                </div>

                {/* Image previews before adding */}
                {localFilter.images.length > 0 && (
                  <div className="mb-3 p-3 rounded" style={{ background: '#f8f9fa', border: '1px dashed #ccc' }}>
                    <span className="text-muted small fw-semibold d-block mb-2">
                      Preview — {localFilter.images.length} image(s) selected:
                    </span>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {localFilter.images.map((img, i) => (
                        <div key={i} style={{ position: 'relative' }}>
                          <img
                            src={typeof img === 'string' ? img : URL.createObjectURL(img)}
                            alt={`preview-${i}`}
                            style={{
                              width: 60, height: 60,
                              objectFit: 'cover',
                              borderRadius: '6px',
                              border: '1px solid #dee2e6',
                              display: 'block'
                            }}
                          />
                          <button
                            type="button"
                            onClick={() => handleRemovePreviewImage(i)}
                            style={{
                              position: 'absolute', top: -6, right: -6,
                              background: '#dc3545', border: 'none',
                              borderRadius: '50%', width: 18, height: 18,
                              color: '#fff', fontSize: 11, lineHeight: '18px',
                              padding: 0, cursor: 'pointer',
                              display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}
                            title="Remove"
                          >✕</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Table */}
                <Table responsive="sm" className="mt-2">
                  <thead>
                    <tr className="text-start">
                      <th>Attribute Type</th>
                      <th>Attribute Value</th>
                      <th>Images</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody style={{ verticalAlign: 'middle' }} className="text-start">
                    {props.filterList && props.filterList.length > 0 ? (
                      props.filterList.map((item, index) => (
                        <tr key={index}>
                          <td>{item.filter_name || item.name || item.main_category_name}</td>
                          <td>{item.filter_value || item.value || item.sub_category_name}</td>
                          <td>
                            {item.images && item.images.length > 0 ? (
                              <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                                {item.images.map((img, i) => (
                                  <img
                                    key={i}
                                    src={typeof img === 'string' ? img : URL.createObjectURL(img)}
                                    alt="img"
                                    style={{
                                      width: 36, height: 36,
                                      objectFit: 'cover',
                                      borderRadius: '4px',
                                      border: '1px solid #dee2e6'
                                    }}
                                  />
                                ))}
                              </div>
                            ) : <span className="text-muted small">—</span>}
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              style={{ border: 'none', background: 'transparent' }}
                              onClick={() => handleRemoveFilter(index)}
                            >
                              <BiTrash style={{ color: 'red', fontSize: 18 }} />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-muted text-center">No attributes added yet.</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;